<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TsFEW/tc-custom/9781467465724.jpg?1728851865262" alt="This image is the cover for the book QAnon, Chaos, and the Cross"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">QAnon, Chaos, and the Cross
      </h1>
      <p class="bookDescription body article font2">
        <b>“What is truth?” said jesting Pilate, and would not stay for an answer. <br/> —Francis Bacon </b><br/>  <br/> Although Christians are followers of the Truth, many find themselves tempted by the alternate “truths” offered by conspiracy theories. Christianity and conspiracy theories have had a long, complicated relationship. But today conspiracy theories are bringing our already polarized society to the brink of chaos. QAnon, the Big Lie, and anti-vaccination theories thrive online, disrupting faith communities. This timely essay collection explores the allure of conspiracy theories and their consequences—and ultimately offers gospel-based paths forward. <br/>  <br/> Accessible to all concerned believers, <i>QAnon, Chaos, and the Cross</i> features scholars of religion, ethics, and public life on the following topics:<br/>      • evaluating evidence and forming beliefs <br/>      • the Satanic Panic of the 1960s–1990s <br/>      • understanding scientific methodology <br/>      • conspiracy theories’ appeal to those searching for meaning <br/>      • the consequences of social media and echo chambers <br/>      • productive dialog with people who hold different opinions <br/>      • intellectualism in the life of faith <br/>      • conspiracy theories in Scripture <br/>      • QAnon’s religious rhetoric <br/>  <br/> Complete with a guide to reasoning, which outlines both logical fallacies and intellectual virtues, <i>QAnon, Chaos, and the Cross</i> is an indispensable resource for all Christians seeking the truth. <p><b>Contributors:</b></p><p> Chase Andre, Michael W. Austin, Bradley Baurain, Daniel Bennett, Gregory L. Bock, Chad Bogosian, Kevin Carnahan, Jason Cook, Scott Culpepper, Stephen Davis, Garrett J. DeWeese, Marlena Graves, Shawn Graves, David Horner, Dru Johnson, Nathan King, Rick Langer, Christian Miller, Timothy Muehlhoff, Michelle Lynn Panchuk, Susan Peppers-Bates, Steven Porter, Kaitlyn Schiess, Aaron Simmons, Domonique Turnipseed, Rachel I. Wightman, Keith Wyma, Eric Yang </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael W. Austin, Gregory L. Bock
      </h2>
      
      <p class="authorDescription body article"><B>Michael W. Austin</B> is Foundation Professor of Philosophy at Eastern Kentucky University and Bonhoeffer Senior Fellow of the Miller Center for Interreligious Learning and Leadership of Hebrew College. He has published twelve books, most recently <I>Humility: Rediscovering the Way of Love and Life in Christ</I> and <I>QAnon, Chaos, and the Cross: Christianity and Conspiracy Theories</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34fab41e